import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line
import { getDownloadAPI } from "@/store/restAPI.js";

// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {

    retrieveLabels({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("label/retrieveLabels").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
    },

    retrieveLabelBatchs({ commit } , filter) {
        commit("SET_LOADING", true);
        return getAPI("label/retrieveLabelBatchs" , filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
    },

    retrieveLabelBatchsBySearch({ commit }, filter) {
        commit("SET_LOADING", true);
        return getAPI("label/retrieveLabelBatchsBySearch" , filter)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
    },

    saveLabelBatch({ commit }, labelBatch) {
      commit("SET_LOADING", true);
      return postAPI("label/saveLabelBatch", labelBatch).then((res) => {
        return res;
      })
        .finally(function () {
          commit("SET_LOADING", false);
        });
    },

    deleteLabelBatch({ commit } , id) {
      commit("SET_LOADING", true);
      return postAPI("label/deleteLabelBatch/" + id).then((res) => {
        return res;
      })
        .finally(function () {
          commit("SET_LOADING", false);
        });
    },

    retrieveLabelBatchById({ commit }, id) {
      commit("SET_LOADING", true);
      return getAPI("label/retrieveLabelBatchById" , id)
        .then((response) => {
          return response;
        })
        .finally(function () {
          commit("SET_LOADING", false);
        });
    },

    downloadPDF({ commit }, id) {
      commit("SET_LOADING", true);
      return getDownloadAPI("label/downloadPDF/" + id)
      .finally(() => commit("SET_LOADING", false));
  },

  calculateBatch({ commit }, request) {
    commit("SET_LOADING", true);
    return getAPI("label/calculateBatch" , request)
      .then((response) => {
        return response;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
},

  countLabelBatchs(context, filter) {
    // Don't set loading for count operations - it's a quick query and causes double loading
    // when called together with retrieveLabelBatchs/retrieveLabelBatchsBySearch
    return getAPI("label/count", filter).then((res) => {
      return res;
    });
  },

  retrieveLabelsWithPallets({ commit }, filter) {
    commit("SET_LOADING", true);
    return getAPI("label/retrieveLabelsWithPallets", filter)
      .then((res) => {
        return res;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  modifyBags({ commit }, request) {
    commit("SET_LOADING", true);
    return postAPI("label/modifyBags", request)
      .then((res) => {
        return res;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };

